import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import PageHeader from "../../components/PageHeader";
import StaffList from "./StaffList";

export default function Staff() {
  const navigate = useNavigate()
  
  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between">
        <PageHeader />
        <div className="flex gap-3">
         <CustomButton
          text="Staff Attendance"
          color="bg-success-500"
          onClick={() => navigate("/staff/staff-attendance")}
        />
        <CustomButton
          text="Add Staff"
          color="bg-primary-500"
          onClick={() => navigate("/staff/add-staff")}
        />
        </div>
      </div>
      <StaffList />
    </div>
  );
}
